import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch } from 'react-redux';
import { showError as error, showSuccess as success } from '../store/slices/layout';

export const useLayout = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const showError = (message) => dispatch(error(message));
  const showSuccess = (message) => dispatch(success(message));

  return {isMobile, theme, showError, showSuccess};
}
